import { Location } from '@angular/common';
import { ActivatedRoute, Router } from '@angular/router';
import { Component, OnInit } from '@angular/core';
import { HelpersService } from '../../services/helpers.service';
import { AuthService } from '../../services/auth.service';
import { MatDialog } from '@angular/material/dialog';
import { HelpDialogComponent } from '../help-dialog/help-dialog.component';
import { Subscription } from 'rxjs';
import { TranslateService } from '@ngx-translate/core';
import { LegacyMigrationService } from '../../services/legacy-migration.service';

@Component({ standalone: false,
  selector: 'vfa-cp-header-fixed',
  templateUrl: './header-fixed.component.html',
  styleUrls: ['./header-fixed.component.scss'],
})
export class HeaderFixedComponent implements OnInit {
  public waitHelp: boolean = false;
  public wait: boolean = false;
  private nspObj: any;
  private token!: string | null;
  private getNspTokenSubscription$: Subscription = new Subscription;
  private getNspsubscription$: Subscription = new Subscription;

  public LANGUAGE_PREFIX: string = '';

  constructor(private location: Location,
    private router: Router,
    public helpersService: HelpersService,
    private legacyMigrationService: LegacyMigrationService,
    private activatedRoute: ActivatedRoute,
    private authService: AuthService,
    private dialog: MatDialog,
    protected translate: TranslateService) {}

  ngOnInit() {
    this.LANGUAGE_PREFIX = this.authService.config?.LANGUAGE_PREFIX || 'language-';
    this.activatedRoute.queryParams.subscribe(params => {
      if (params['details']) {
        this.token = encodeURIComponent(params['details']);
      } else {
        this.token = null;
      }
    });
  }

  private getNspToken(token: string | null) {
    if (this.getNspTokenSubscription$ instanceof Subscription) {
      this.getNspTokenSubscription$.unsubscribe();
    }
    this.waitHelp = true;
    this.getNspTokenSubscription$ = this.authService.getNSPToken(token).subscribe(res => {
      this.nspObj = res;
      this.createNSP();
      this.waitHelp = false;
    })
  }

  private getNsp() {
    if (this.getNspsubscription$ instanceof Subscription) {
      this.getNspsubscription$.unsubscribe();
    }
    this.waitHelp = true;
    this.getNspsubscription$ = this.authService.getNSP().subscribe(res => {
      this.nspObj = res;
      this.createNSP();
      this.waitHelp = false;
    }, err => {
      if (this.helpersService.userInfo && this.helpersService.userInfo.token_email) {
        this.getNspToken(this.helpersService.userInfo.token_email);
        this.createNSP();
      }
    })
  }

  public swalNSP() {
    if (this.token) {
      this.getNspToken(this.token);
    } else if (this.authService.storageAccessToken) {
      this.getNsp();
    } else if (this.helpersService.userInfo && this.helpersService.userInfo.token_email) {
      this.getNspToken(this.helpersService.userInfo.token_email);
    }
  }

  private createNSP() {
    const NSPtitle = this.helpersService.instant("nsp-title");
    let NSPemail = null;
    let NSPphone = null;
    let NSPsoc = null;
    if (this.nspObj && this.nspObj.Account.NSP_Contact__r) {
      NSPemail = this.nspObj.Account.NSP_Contact__r.Email;
      NSPphone = this.nspObj.Account.NSP_Contact__r.Phone;
      NSPsoc = this.nspObj.Account.NSP_Contact__r.SOC_Phone_Number__c;
    }
    const nspTitle = this.helpersService.instant("nsp-modal-title");
    const nspTitleContacts = this.helpersService.instant("nsp-modal-title-contacts");
    const nspDescription = this.helpersService.instant("nsp-modal-description");
    const nspEmailTranslation = this.helpersService.instant("input-email-label");
    const nspSOCTranslation = this.helpersService.instant("nsp-soc-number");
    const npsSOCLinkTranslation = this.helpersService.instant("nsp-soc-description");
    const nspPhoneTranslation = this.helpersService.instant("input-phone-label");
    const openTicket = this.helpersService.instant("nsp-send-button");
    const openContacts = this.helpersService.instant("nsp-contacts-button");
    this.dialog.open(HelpDialogComponent,
      {
        panelClass: 'help-dialog-container', data: {
          "isSOC": this.nspObj.Account.NSP_Contact__r.SOC_Phone_Number__c ? true : false,
          "isSupport": this.nspObj.onBoardingCompleted,
          "NSPemail": NSPemail,
          "NSPphone": NSPphone,
          "NSPsoc": NSPsoc,
          "nspTitle": nspTitle,
          "nspTitleContacts": nspTitleContacts,
          "nspDescription": nspDescription,
          "nspEmailTranslation": nspEmailTranslation,
          "nspSOCTranslation": nspSOCTranslation,
          "nspSOCLinkTranslation": npsSOCLinkTranslation,
          "nspPhoneTranslation": nspPhoneTranslation,
          "openTicket": openTicket,
          "openContacts": openContacts
        }
      });
  }

  public back(): void {
    if (this.helpersService.navigateTo) {
      this.router.navigateByUrl(this.helpersService.navigateTo);
    } else if (window.location.pathname.includes("/orders/")) {
      this.helpersService.undoUserState();
    } else if (window.location.pathname.includes("/legacy-migration/")) {
      this.legacyMigrationService.undoLegacyUserState();
    } else {
      this.location.back();
    }
  }
}

